export const colorsV2 = {
  text: {
    light: {
      primary: '#000000',
      secondary: '#444444',
      tertirary: '#949494',
      quaternary: '#D4D4D4',
      senary: '#FFFFFF',
      danger: '#FB1010',
      'danger-dark': '#C63256',
      info: '#E832D2',
      success: '#66B004',
      'success-subtle': '#D2F7A1',
      light: '#F7F7EB',
      white: '#FFFFFF',
    },
    dark: {
      primary: '#444444',
      secondary: '#949494',
      tertirary: '#D4D4D4',
      quaternary: '#FFFFFF',
      senary: '#000000',
      danger: '#FB1010',
      'danger-dark': '#C63256',
      info: '#E832D2',
      success: '#66B004',
      'success-subtle': '#D2F7A1',
      light: '#F7F7EB',
      white: '#FFFFFF',
    },
  },
  icon: {
    light: {
      primary: '#000000',
      secondary: '#444444',
      tertiary: '#949494',
      quaternary: '#D4D4D4',
      senary: '#FFFFFF',
      danger: '#FB1010',
      info: '#E832D2',
      success: '#66B004',
      'success-subtle': '#D2F7A1',
    },
    dark: {
      primary: '#FFFFFF',
      secondary: '#949494',
      tertiary: '#D4D4D4',
      quaternary: '#D4D4D4',
      senary: '#D4D4D4',
      danger: '#FB1010',
      info: '#E832D2',
      success: '#66B004',
      'success-subtle': '#D2F7A1',
    },
  },
  accent: {
    light: {
      primary: '#C8F996',
      'primary-light': 'rgba(200, 249, 150, 0.3)',
      'primary-lighter': 'rgba(200, 249, 150, 0.15)',
      secondary: '#7632E8',
      'secondary-light': 'rgba(118, 50, 232, 0.3)',
      tertiary: '#E832D2',
      'tertiary-light': 'rgba(232, 50, 210, 0.3)',
      'tertiary-lighter': 'rgba(232, 50, 210, 0.15)',
      quaternary: '#812C9D',
      'quaternary-light': 'rgba(129, 44, 157, 0.3)',
      senary: '#870051',
      'senary-light': 'rgba(135, 0, 81, 0.3)',
      septenary: '#4C269C',
      'septenary-light': 'rgba(76, 38, 156, 0.3)',
    },
    dark: {
      primary: '#C8F996',
      'primary-light': 'rgba(200, 249, 150, 0.3)',
      'primary-lighter': 'rgba(200, 249, 150, 0.15)',
      secondary: '#7632E8',
      'secondary-light': 'rgba(118, 50, 232, 0.3)',
      tertiary: '#E832D2',
      'tertiary-light': 'rgba(232, 50, 210, 0.3)',
      'tertiary-lighter': 'rgba(232, 50, 210, 0.15)',
      quaternary: '#812C9D',
      'quaternary-light': 'rgba(129, 44, 157, 0.3)',
      senary: '#870051',
      'senary-light': 'rgba(135, 0, 81, 0.3)',
      septenary: '#4C269C',
      'septenary-light': 'rgba(76, 38, 156, 0.3)',
    },
  },
  stroke: {
    light: {
      primary: '#4A4A4A',
      secondary: 'rgba(74, 74, 74, 0.1)',
      tertiary: 'rgba(200, 249, 150, 0.5)',
      quaternary: 'rgba(200, 249, 150, 0.3)',
      danger: '#FB1010',
      white: '#ffffff',
    },
    dark: {
      primary: '#4A4A4A',
      secondary: 'rgba(255, 255, 255, 0.1)',
      tertiary: 'rgba(200, 249, 150, 0.5)',
      quaternary: 'rgba(200, 249, 150, 0.3)',
      danger: '#FB1010',
      white: '#ffffff',
    },
  },
  background: {
    light: {
      primary: '#F3F3F3',
      secondary: '#FEFEFE',
      tertiary: 'rgba(0, 0, 0, 0.04)',
      quaternary: '#292729',
      darkButtonFocused: '#363636',
      lightGray: '#FBFAF9',
      darkGray: '#231F20',
      darkGray2: '#1E1E1E',
      danger: '#FB1010',
      'danger-light': '#FAEBEE',
      white: '#ffffff',
      green: '#66B004',
      greenSecondary: '#7FBC41',
      black: '#000000',
    },
    dark: {
      primary: '#000000',
      secondary: '#191719',
      tertiary: 'rgba(255, 255, 255, 0.07)',
      quaternary: '#292729',
      darkButtonFocused: '#363636',
      lightGray: '#FBFAF9',
      darkGray: '#231F20',
      darkGray2: '#1E1E1E',
      danger: '#FB1010',
      'danger-light': '#FAEBEE',
      white: '#ffffff',
      green: '#66B004',
      greenSecondary: '#7FBC41',
      black: '#000000',
    },
  },
}
